"use strict";
// ----- autogen:polyfills:start  -----
// This field will be automatically injected into the ./dist/packages/<package-name>/index.js file
// between the autogen:polyfills:start/end comments

try {
  globalThis.crypto = require('crypto').webcrypto;
} catch (e) {
  // swallow
}

// ----- autogen:polyfills:end  -----
Object.defineProperty(exports, "__esModule", { value: true });
exports.uint8arrayToString = exports.uint8arrayFromString = void 0;
const uint8arrays_1 = require("./lib/uint8arrays");
Object.defineProperty(exports, "uint8arrayFromString", { enumerable: true, get: function () { return uint8arrays_1.uint8arrayFromString; } });
Object.defineProperty(exports, "uint8arrayToString", { enumerable: true, get: function () { return uint8arrays_1.uint8arrayToString; } });
//# sourceMappingURL=index.js.map